<template>
<div class="main">
    <el-tabs v-model="aba" type="border-card" v-loading="carregando">

        <!-- ========================= COMPETÊNCIA ========================= -->
        <el-tab-pane label="Competência" name="competencia">
            <param-editor v-for="p in grupo('competencia')" :key="p.chave"
                :p="p" :valor="valores[p.chave]" :rotulo="rotulo(p.chave)" :opcoes="opcoes[p.chave]"
                :min="1" :max="28" @input="alterar(p.chave, $event)"></param-editor>

            <div class="u-text-right u-mt-15">
                <el-button type="primary" icon="el-icon-check" @click="salvar" :disabled="!alterado">SALVAR</el-button>
            </div>
        </el-tab-pane>

        <!-- ========================== EXPORTAÇÃO ========================= -->
        <el-tab-pane label="Exportação" name="exportacao">
                        
            <param-editor v-for="p in grupo('exportacao')" :key="p.chave"
                :p="p" :valor="valores[p.chave]" :rotulo="rotulo(p.chave)" :opcoes="opcoes[p.chave]"
                @input="alterar(p.chave, $event)"></param-editor>

            <div class="u-text-right u-mt-15">
                <el-button type="primary" icon="el-icon-check" @click="salvar" :disabled="!alterado">SALVAR</el-button>
            </div>
        </el-tab-pane>

        <!-- ======================== INTEGRAÇÃO RH ======================== -->
        <el-tab-pane label="Integração com o RH" name="integracao">
            
            <param-editor v-for="p in grupo('integracao')" :key="p.chave"
                :p="p" :valor="valores[p.chave]" :rotulo="rotulo(p.chave)" :opcoes="opcoes[p.chave]"
                :max="99999" @input="alterar(p.chave, $event)"></param-editor>

            <el-alert v-if="conexao" :type="conexao.ok ? 'success' : 'error'" :closable="false"
                class="u-mt-15" :title="conexao.msg"></el-alert>

            <div class="u-text-right u-mt-15">
                <el-button plain icon="el-icon-refresh" @click="limparCache">LIMPAR CACHE DO RH</el-button>
                <el-button plain icon="el-icon-link" @click="testarConexao" :loading="testando">TESTAR CONEXÃO</el-button>
                <el-button type="primary" icon="el-icon-check" @click="salvar" :disabled="!alterado">SALVAR</el-button>
            </div>
        </el-tab-pane>

        <!-- ============================ TELAS ============================ -->
        <el-tab-pane label="Telas" name="telas">
            
            <param-editor v-for="p in grupo('telas')" :key="p.chave"
                :p="p" :valor="valores[p.chave]" :rotulo="rotulo(p.chave)" :opcoes="opcoes[p.chave]"
                :min="1" :max="500" @input="alterar(p.chave, $event)"></param-editor>

            <div class="u-text-right u-mt-15">
                <el-button type="primary" icon="el-icon-check" @click="salvar" :disabled="!alterado">SALVAR</el-button>
            </div>
        </el-tab-pane>

        <!-- ========================= INSTITUIÇÕES ======================== -->
        <el-tab-pane label="Instituições" name="instituicoes">
            <aba-catalogo recurso="instituicoes" modo="instituicao"
                @erro="erro"></aba-catalogo>
        </el-tab-pane>

        <!-- ======================= EVENTOS DA GRADE ====================== -->
        <el-tab-pane label="Eventos da Grade" name="eventos">
            <aba-eventos-grade @erro="erro"></aba-eventos-grade>
        </el-tab-pane>

        <!-- ======================== TIPOS DE FALTA ======================= -->
        <el-tab-pane label="Tipos de Falta" name="faltas">
            <aba-catalogo recurso="tipos-falta" modo="falta" catalogo="falta" :eventos="eventos"
                @erro="erro"></aba-catalogo>
        </el-tab-pane>

        <!-- ======================= TIPOS DE LICENÇA ====================== -->
        <el-tab-pane label="Tipos de Licença" name="licencas">
            <aba-catalogo recurso="afastamentos" modo="afastamento" catalogo="afastamento"
                rotuloJustificativa="Entra na justificativa"
                @erro="erro"></aba-catalogo>
        </el-tab-pane>

        <!-- ====================== VALIDADOR DE LINHA ===================== -->
        <el-tab-pane label="Validador de Linha" name="validador">
            <aba-validador @erro="erro"></aba-validador>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import ParamEditor from './param-editor'
import AbaCatalogo from './aba-catalogo'
import AbaValidador from './aba-validador'
import AbaEventosGrade from './aba-eventos-grade'

// Agrupamento dos parâmetros por aba. A ordem aqui é a ordem exibida.
const GRUPOS = {
    competencia: ['competencia_dia_corte', 'competencias_bloqueadas'],
    exportacao: [
        'export_campo_registro', 'export_meio_dia', 'export_linha_por_dia', 'export_unidade_custeio',
        'export_nome_arquivo', 'export_encoding', 'export_quebra_linha'
    ],
    integracao: ['sip_url', 'sip_entidade', 'sip_timeout', 'sip_cache_minutos', 'sip_pagina_servidores'],
    telas: [
        'ferias_dias_padrao', 'ferias_dias_max', 'consulta_itens_por_pagina',
        'excluir_somente_ultimo', 'justificativa_automatica'
    ]
}

// Rótulos amigáveis — a chave técnica continua visível abaixo de cada campo.
const ROTULOS = {
    competencia_dia_corte: 'Dia de início da competência',
    competencias_bloqueadas: 'Competências fechadas',
    export_campo_registro: 'Identificação do servidor no arquivo (posições 004-013)',
    export_meio_dia: 'Como enviar a ausência de meio período',
    export_linha_por_dia: 'Uma linha por dia do período da falta',
    export_unidade_custeio: 'Unidade/Custeio (posições 041-046)',
    export_nome_arquivo: 'Nome do arquivo gerado',
    export_encoding: 'Codificação do arquivo',
    export_quebra_linha: 'Quebra de linha',
    sip_url: 'Endereço dos webservices do RH',
    sip_entidade: 'Código da entidade no RH',
    sip_timeout: 'Tempo limite das consultas (segundos)',
    sip_cache_minutos: 'Cache dos catálogos (minutos)',
    sip_pagina_servidores: 'Servidores por página na leitura do RH',
    ferias_dias_padrao: 'Dias de férias sugeridos',
    ferias_dias_max: 'Dias de férias no máximo',
    consulta_itens_por_pagina: 'Servidores por página na consulta',
    excluir_somente_ultimo: 'Permitir excluir apenas o lançamento mais recente',
    justificativa_automatica: 'Preencher a Justificativa de Licenças e Férias automaticamente'
}

const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
    'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']

export default {
    components: { ParamEditor, AbaCatalogo, AbaValidador, AbaEventosGrade },
    data: () => ({
        aba: 'competencia',
        carregando: true,
        carregandoEventos: false,
        testando: false,
        alterado: false,
        parametros: [],
        opcoes: {},
        valores: {},
        eventos: [],
        conexao: null
    }),
    computed: {
        
    },
    mounted () {
        this.getParametros()
        this.getEventos()
    },
    methods: {
        baseUrl () {
            return `${this.$store.state.config.baseUrlApi}/api/folha-ponto`
        },
        pad (n) {
            return String(n).padStart(2, '0')
        },
        rotulo (chave) {
            return ROTULOS[chave] || chave
        },
        grupo (nome) {
            const chaves = GRUPOS[nome] || []
            return chaves.map(c => this.parametros.find(p => p.chave === c)).filter(Boolean)
        },
        alterar (chave, valor) {
            this.$set(this.valores, chave, valor)
            this.alterado = true
        },
        erro (e) {
            const msg = e && e.response && e.response.data && e.response.data.throw
                ? e.response.data.throw.msg
                : 'Não foi possível concluir a operação. Tente novamente.'

            window.eventBus.$emit('alert', { msg, type: 'error' })
            this.$store.commit('throwException', e)
        },
        getParametros () {
            this.carregando = true
            this.$axios.get(`${this.baseUrl()}/configuracao/parametros`, this.$store.getters.getHeaderAuth)
                .then(res => {
                    this.parametros = res.data.parametros || []
                    this.opcoes = res.data.opcoes || {}

                    const valores = {}
                    this.parametros.forEach(p => { valores[p.chave] = p.valor })
                    this.valores = valores

                    this.alterado = false
                    this.carregando = false
                })
                .catch(e => { this.carregando = false; this.erro(e) })
        },
        getEventos () {
            this.carregandoEventos = true
            this.$axios.get(`${this.baseUrl()}/eventos-catalogo`, this.$store.getters.getHeaderAuth)
                .then(res => { this.eventos = res.data || []; this.carregandoEventos = false })
                .catch(e => { this.carregandoEventos = false; this.erro(e) })
        },
        salvar () {
            window.eventBus.$emit('loading', true)

            this.$axios.post(`${this.baseUrl()}/configuracao/parametros`, { valores: this.valores }, this.$store.getters.getHeaderAuth)
                .then(res => {
                    this.parametros = res.data.parametros || this.parametros

                    const valores = {}
                    this.parametros.forEach(p => { valores[p.chave] = p.valor })
                    this.valores = valores

                    this.alterado = false
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                })
                .catch(e => { window.eventBus.$emit('loading', false); this.erro(e) })
        },
        testarConexao () {
            this.testando = true
            this.conexao = null

            this.$axios.post(`${this.baseUrl()}/configuracao/testar-conexao`, {}, this.$store.getters.getHeaderAuth)
                .then(res => {
                    this.testando = false
                    this.conexao = res.data

                    if (res.data.ok) {
                        this.conexao.msg = `${res.data.msg} Entidade ${res.data.entidade} — `
                            + `${res.data.totais.instituicoes} instituição(ões) e ${res.data.totais.eventos} evento(s) lidos.`
                    }
                })
                .catch(e => { this.testando = false; this.erro(e) })
        },
        limparCache () {
            window.eventBus.$emit('loading', true)

            this.$axios.post(`${this.baseUrl()}/limpar-cache`, {}, this.$store.getters.getHeaderAuth)
                .then(() => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Cache do sistema de RH atualizado.', type: 'success' })
                    this.getEventos()
                })
                .catch(e => { window.eventBus.$emit('loading', false); this.erro(e) })
        }
    }
}
</script>
